module.exports = "pegasus_template/assets/blocks/column-10-theme3.png";